import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RunnableClass;
function Runnable() {
  if (RunnableClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Runnable');
    RunnableClass = $;
  }
  return RunnableClass;
}
//region block: exports
export {
  Runnable as Runnablezd7bpy5et5p0,
};
//endregion

//# sourceMappingURL=Runnable.mjs.map
